<template>
  <FilterGroup
    v-if="modelValue"
    :badge="modelValue.length"
    :label="filter.name"
    :is-collapsible="isCollapsible"
    :filter-slug="filter.slug"
    @click:reset="handleReset"
    @click:apply="handleApply"
    @reset-to-initial-state="handleResetToInitialState"
  >
    <MultipleSelectionList
      :model-value="tempModelValue"
      :items="sortedFilterValues"
      :use-deep-is-active-check="true"
      :initial-state="modelValue"
      :is-reset="isReset"
      class="mx-2 mt-2 flex flex-wrap"
      name="FilterSelectSize"
      @update:model-value="handleModelValueUpdate"
    >
      <template #item="{ item, toggleItem, isActive }">
        <Button
          :class="{ 'font-bold': isActive }"
          class="mb-2 mr-2 text-xs focus:ring-2"
          type="ghost"
          @click="toggleItem(item)"
          >{{ item.displayName }}
        </Button>
      </template>
    </MultipleSelectionList>
  </FilterGroup>
</template>

<script lang="ts">
import type { ProductFilter } from '@scayle/storefront-nuxt'
import FilterGroup from '~/components/filters/FilterGroup.vue'
import MultipleSelectionList from '../../../components/ui/selectionList/MultipleSelectionList.vue'
import { useDeviceType } from '~/composables/useDeviceType'

export default defineComponent({
  name: 'SizeFilter',
  components: { MultipleSelectionList, FilterGroup },
  props: {
    modelValue: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    filter: {
      type: Object as PropType<ProductFilter>,
      required: true,
    },
    filterValues: {
      type: Array as PropType<any[]>,
      required: true,
    },
    isCollapsible: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ['reset', 'apply', 'update:modelValue', 'update:modelValueIds'],

  setup(props, { emit }) {
    const isReset = ref<boolean>(false)
    const { showNewDesktopPlpQuickFilters } = useExperiments()
    const { isMobileOrTablet } = useDeviceType()
    const tempModelValue = ref(props.modelValue)

    const handleReset = () => {
      isReset.value = false
      tempModelValue.value = props.modelValue

      nextTick(() => {
        isReset.value = true
        emit('reset')
      })
    }

    const handleResetToInitialState = () => {
      isReset.value = false
      tempModelValue.value = props.modelValue

      nextTick(() => {
        isReset.value = true
      })
    }

    const handleApply = () => {
      isReset.value = false
      emit('update:modelValue', tempModelValue)
      emit(
        'update:modelValueIds',
        tempModelValue.value.map((item: any) => item.value),
      )
      emit('apply', {
        values: tempModelValue.value.map((item: any) => item.value),
        displayNames: tempModelValue.value.map((item: any) => item.displayName),
      })
    }

    const handleModelValueUpdate = (newValue: any[]) => {
      tempModelValue.value = newValue
      if (
        !showNewDesktopPlpQuickFilters.value ||
        (showNewDesktopPlpQuickFilters.value && isMobileOrTablet.value)
      ) {
        emit('update:modelValue', tempModelValue)
        emit(
          'update:modelValueIds',
          tempModelValue.value.map((item: any) => item.value),
        )
      }
    }

    watch(
      () => props.modelValue,
      (newModelValue) => {
        tempModelValue.value = newModelValue
      },
      { deep: true },
    )

    return {
      sortedFilterValues: computed(() =>
        sortSizeFilterValues(props.filterValues),
      ),
      handleReset,
      handleApply,
      handleResetToInitialState,
      handleModelValueUpdate,
      isReset,
      tempModelValue,
    }
  },
})
</script>
